import React, { useState } from 'react';
import styled, { css, useTheme } from 'styled-components';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionItemBodyWithAnimation,
  AccordionItemHeading,
  Box,
  RawHtml,
  Text,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useAuthorableContents } from 'shared/providers/AuthorableContentsProvider';
import slugify from 'shared/utils/slugify';

const Title = styled(Text)`
  ${({ theme: { media, spacing } }) => css`
    margin: 0 auto ${spacing.s4};
    width: 100%;
    text-align: center;

    ${media.up('big')} {
      margin-bottom: ${spacing.s7};
    }
  `}
`;

const FAQAccordion = () => {
  const [currentExpandedItems, setCurrentExpandedItems] = useState<string[]>(
    [],
  );

  const { palette } = useTheme();

  const { contents, getText } = useAuthorableContents();

  const faqContents = Object.entries(contents).filter((content) =>
    content[0].includes('faqs.question'),
  );

  if (!faqContents.length) {
    return null;
  }

  return (
    <Box pt={['s5', 's7', 's9']}>
      <LinkRegion regionId="Important things to know">
        <Title variant="headingS">Important things to know</Title>
        <Accordion
          allowMultipleExpanded
          onChange={(expandedItems: string[]) => {
            setCurrentExpandedItems(expandedItems);
            trackCustomLink(expandedItems?.[0]);
          }}
        >
          {faqContents.map((_, index) => {
            const title = getText(`faqs.question${index + 1}`);
            const content = getText(`faqs.answer${index + 1}`);
            const id = slugify(title);

            return (
              <AccordionItem
                key={id}
                uuid={id}
                isOpen={currentExpandedItems.includes(id)}
              >
                <AccordionItemHeading>
                  <Text variant="subheadingM">{title}</Text>
                  <AccordionButton />
                </AccordionItemHeading>
                <AccordionItemBodyWithAnimation
                  isOpen={currentExpandedItems.includes(id)}
                >
                  <RawHtml
                    color={palette.baseColors.newZealandBlack}
                    variant="bodySMedium"
                    html={content}
                  />
                </AccordionItemBodyWithAnimation>
              </AccordionItem>
            );
          })}
        </Accordion>
      </LinkRegion>
    </Box>
  );
};

export default FAQAccordion;
